export const ActivityReport = {
    path: '/activity_report',
    name: 'activity_report',
    component: () => import('@/views/Report/ActivityReport.vue')
}